module.exports = __webpack_public_path__ + "img/Tableta_PapasHabla.380286bb.png";